<template>
    <div>
        <div class="flex items-center">
            <h2 class="section-title">{{$t('pages.dashboard.components.tta_performance.title')}}</h2>
        </div>
        <div class="w-full block xl:flex xl:flex-row mt-3 space-x-0 xl:space-x-4" v-if="lastThirtyPyramidAuctions.length > 0">
            <div class="w-full xl:w-6/12">
                <div class="bg-white tile h-full">
                    <div class="p-5">
                        <div class="chart-inner-headline pb-4">{{$t('pages.dashboard.components.pp_last_thirty_days.label')}}</div>
                        <pp-last-thirty-days-bar
                            :labels="lastThirtyDaysLabels"
                            :data="visitorsLastThirtyDays"
                            :chartLabel="$t('pages.dashboard.components.pp_last_thirty_days.chart_label')"
                            :width="400"
                        />
                    </div>
                </div>
            </div>
            <div class="w-full xl:w-6/12 mt-8 xl:mt-0">
                <div class="bg-white tile h-full">
                    <div class="p-5">
                        <div class="text-left pb-3 font-medium text-lg">
                            <span class="">{{$t('pages.dashboard.components.fs_last_thirty_days.label_1' + this.$page.props.tenant.labels_key)}}</span>
                            <span class="text-gray-500">{{$t('pages.dashboard.components.fs_last_thirty_days.label_2' + this.$page.props.tenant.labels_key)}}</span>
                            <span class="">{{$t('pages.dashboard.components.fs_last_thirty_days.label_3' + this.$page.props.tenant.labels_key)}}</span>
                        </div>
                        <fs-last-thirty-days-stacked-bar
                            :labels="lastThirtyDaysLabels"
                            :data="fsLastThirtyDays"
                            :label-demand="$t('pages.dashboard.components.fs_last_thirty_days.label_demand')"
                            :label-sales="$t('pages.dashboard.components.fs_last_thirty_days.label_sales')"
                            :chartLabel="$t('pages.dashboard.components.fs_last_thirty_days.chart_label')"
                            :width="400"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex items-end pt-4">
            <button @click="goToAuctionAnalytics()" type="button" class="btn btn-primary ml-auto"
                    v-if="lastThirtyPyramidAuctions.length > 0">
                {{$t('pages.dashboard.components.tta_performance.goto_auction_analytics_button_label')}}
            </button>
        </div>
        <div class="bg-white tile my-5" v-if="lastThirtyPyramidAuctions.length === 0">
            <div class="px-4 py-5 sm:p-6">
                <div class="flex sm:items-start sm:justify-between">
                    <div class="flex">
                        <h3 class="text-xl leading-6 font-medium mr-5"><icon name="emoji-sad" class="h-10"/></h3>
                        <div class="mt-2 max-w-xl text-sm text-gray-500">
                            <p>{{$t('pages.dashboard.components.tta_performance.no_auction')}}</p>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
                        <button @click="goToAuctionAnalytics()" type="button" class="btn btn-primary">
                            {{$t('pages.dashboard.components.tta_performance.goto_auction_analytics_button_label')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Layout from '@/Shared/Layout';
import PpLastThirtyDaysBar from "@/Shared/Charts/PpLastThirtyDaysBar";
import Icon from "@/Shared/Icon";
import moment from "moment";
import FsLastThirtyDaysStackedBar from "../../../Shared/Charts/FsLastThirtyDaysStackedBar.vue";

export default {
    layout: Layout,
    components: {
        PpLastThirtyDaysBar,
        FsLastThirtyDaysStackedBar,
        Icon
    },
    props: {
        lastThirtyPyramidAuctions: Array,
    },
    methods: {
        goToAuctionAnalytics() {
            this.$inertia.visit(
                route('auctions.analytics')
            );
        },
        floorSalesForDay(auction) {
            return auction.bids.reduce((accumulator, bid) => {
                return accumulator + (bid.quantity * bid.amount);
            }, 0);
        },
        salesForDay(auction) {
            let sales = auction.bids.filter(b => b.status === 4);
            if(sales.length > 0) {
                return sales.reduce((accumulator, bid) => {
                    return accumulator + (bid.quantity * bid.amount);
                }, 0);
            }
            return 0;
        }
    },
    computed: {
        lastThirtyDaysLabels: function() {
            let retVal = [];
            for(let i=30; i>0; i--) {
                retVal.push(moment().subtract(i,'d').format(window.i18n.t('locale.formatDay')));
            }
            return retVal;
        },
        fsLastThirtyDays: function() {
            let sales = Array(30).fill(0);
            let demand = Array(30).fill(0);
            // check date and put the value in the corresponding index according to how old the auction FS are
            let today = new Date();
            today.setHours(0,0,0,0);

            this.lastThirtyPyramidAuctions.forEach((auction) => {
               let currentDay = new Date(auction.date_start);
               currentDay.setHours(0,0,0,0);
               let diffInDays = parseInt( 0.5 + (today.getTime() - currentDay.getTime()) / (1000 * 60 * 60 * 24));
               if (diffInDays > 0 && diffInDays <= 30) {
                   sales[30 - diffInDays] = this.salesForDay(auction);
                   demand[30 - diffInDays] = this.floorSalesForDay(auction);
               }
            });
            return [sales, demand];
        },
        visitorsLastThirtyDays: function() {
            // // check date and put the value in the corresponding index according to how old the auction FS are
            let today = new Date();
            today.setHours(0,0,0,0);
            let retVal =  Array(30).fill(0);
            this.lastThirtyPyramidAuctions.forEach((auction) => {
               let currentDay = new Date(auction.date_start);
               currentDay.setHours(0,0,0,0);
               let diffInDays =  parseInt(0.5 + (today.getTime() - currentDay.getTime()) / (1000 * 60 * 60 * 24));
               if (diffInDays > 0 && diffInDays <= 30) {
                   retVal[30 - diffInDays] = auction?.visitors?.visitor_count || 0;
               }
            });
            return retVal;
        }
    }
}
</script>
